<ng-container *ngIf="label">
    <ng-container *ngIf="routerLink; else regularButton">
        <button
            mat-ripple
            class="ds-button"
            type="button"
            [disabled]="isDisabled || isLoading"
            [ngClass]="buttonClasses"
            [queryParams]="queryParams"
            [routerLink]="routerLink"
            [routerLinkActive]="routerLink ? 'active' : null"
        >
            <ng-template [ngTemplateOutlet]="buttonContent"></ng-template>
        </button>
    </ng-container>

    <ng-template #regularButton>
        <button mat-ripple class="ds-button" [disabled]="isDisabled || isLoading" [ngClass]="buttonClasses" (click)="buttonClick.emit()">
            <ng-template [ngTemplateOutlet]="buttonContent"></ng-template>
        </button>
    </ng-template>
</ng-container>

<ng-template #buttonContent>
    <ds-loading-spinner *ngIf="isLoading; else iconTpl" class="ds-button__spinner" theme="inherit" size="xs"></ds-loading-spinner>
    <ng-template #iconTpl>
        <mat-icon *ngIf="icon" [fontSet]="iconFontSet">{{ icon }}</mat-icon>
    </ng-template>

    <span>{{ label }}</span>
</ng-template>
